<div class="page-layout blank p-24" fusePerfectScrollbar fxLayoutAlign="center center" fxLayout="column">

    <div fxLayout="column" fxFlex="80">


        <h4>Perfil</h4>

        <form [formGroup]="profileForm" fxFlex="50">

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Nome</mat-label>
                <input formControlName="nomePaciente" matInput readonly />
            </mat-form-field>
            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>CPF</mat-label>
                <input formControlName="cpf" matInput readonly />
            </mat-form-field>
            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Aniversário</mat-label>
                <input type="text" formControlName="dataNascimento" matInput readonly />
            </mat-form-field>

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Telefone</mat-label>
                <input formControlName="telefone" matInput mask="{{ phoneMask }}" />
            </mat-form-field>
            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>Celular</mat-label>
                <input formControlName="telefoneCelular" matInput mask="{{ celMask }}" />
            </mat-form-field>

            <mat-form-field class="w-100-p" appearance="outline">
                <mat-label>E-mail</mat-label>
                <input formControlName="email" matInput />
            </mat-form-field>
           
        </form>

    </div>
</div>